import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { TagList } from "../../common/tag-list";
import { getMarketplaceOrderTags } from "../marketplace-order-tags";

const catalogEntry = fgColumnEntries["shopify-order-tags"];

export const ShopifyOrderTagsColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => {
    const renderedTags = getMarketplaceOrderTags(row);
    return (
      <Flex pl="lg">
        {" "}
        <TagList compactFallback hoverToShow tags={renderedTags} />{" "}
      </Flex>
    );
  },
  width: catalogEntry.defaultWidth,
};
